import { LoaderFunction, Outlet } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { User } from '../types';
import { GlobalContextProvider } from '../contexts/globalContext';
import { routeFetchApi } from '../utils/fetchApi';
import { useUser } from '../hooks/useUser';

export const loader: LoaderFunction = () => {
  return routeFetchApi<User>(
    {
      url: '/api/users/me',
      method: 'POST',
    },
    (user) => {
      Sentry.setUser({ id: user.id });

      return user;
    }
  );
};

export const Component = () => {
  const user = useUser();

  return (
    <div className="h-screen overflow-hidden">
      <GlobalContextProvider
        initState={{ user, hasCheckedBasicPlanOnboarding: false }}
      >
        <Outlet />
      </GlobalContextProvider>
    </div>
  );
};
